// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.reports-page {
  width: 100%;
  min-width: 0;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.reports-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0 0 1.35rem;
}

.reports-heading-copy {
  min-width: 0;
}
.reports-heading-copy h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.55rem, 2.3vw, 1.95rem);
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.25;
}
.reports-heading-copy > p:last-child {
  max-width: 740px;
  margin: 0.5rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.reports-eyebrow {
  display: flex;
  align-items: center;
  margin: 0 0 0.45rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.69rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.reports-header-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  flex: 0 0 3.5rem;
  border: 1px solid rgba(40, 80, 173, 0.15);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.45rem;
}

.report-toolbar-card {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  min-width: 0;
  margin-bottom: 1.25rem;
  padding: 1rem 1.15rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.filter-block {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 15rem;
}

.toolbar-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.filter-copy {
  min-width: 0;
  flex: 1 1 auto;
}
.filter-copy .form-label {
  display: block;
  margin: 0 0 0.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.74rem;
  font-weight: 650;
}

.report-filter {
  width: 100%;
  min-width: 10.5rem;
  min-height: 2.5rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
}
.report-filter:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
}
.report-filter:disabled {
  background-color: var(--ca-bg-secondary, #eef2f8);
  cursor: wait;
}

.report-toolbar-divider {
  align-self: stretch;
  width: 1px;
  background: var(--ca-border-light, #e9edf3);
}

.report-action-copy {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 10rem;
}

.toolbar-label {
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
  font-weight: 700;
}

.toolbar-hint {
  margin-top: 0.2rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.report-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.report-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.6rem 0.9rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  font-weight: 650;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.report-action-btn i {
  font-size: 0.95rem;
}
.report-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.reports-page .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.reports-page .btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}
.reports-page .btn-primary:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.2);
}

.reports-page .btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.reports-page .btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary-light, #2850ad);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary-dark, #0d2863);
}

.reports-loading-banner,
.reports-alert {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin: 0 0 1rem;
  padding: 0.8rem 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.reports-loading-banner .spinner-border,
.panel-loading .spinner-border {
  color: var(--ca-primary, #0e2e80);
}

.reports-alert-error {
  border-color: #f3b9c0;
  background: var(--ca-danger-bg, #fdecef);
  color: #842029;
}
.reports-alert-error .btn {
  margin-left: auto;
}

.pdf-preview-panel {
  overflow: hidden;
  margin: 0 0 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.pdf-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fbfcff;
}

.pdf-preview-heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.pdf-preview-heading h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
  font-weight: 750;
}
.pdf-preview-heading p {
  margin: 0.2rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  text-transform: capitalize;
}

.pdf-preview-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 2.5rem;
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.1rem;
}

.close-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex: 0 0 auto;
  font-size: 0.8rem;
}

.pdf-viewer {
  display: block;
  width: 100%;
  height: min(78vh, 900px);
  min-height: 440px;
  border: 0;
  background: #eef2f8;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 1.15rem;
}

.report-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 350px;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.report-panel:hover {
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.report-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 5.35rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
}

.panel-heading-copy {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.panel-heading-copy h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.96rem;
  font-weight: 750;
  line-height: 1.35;
}
.panel-heading-copy p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  line-height: 1.45;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.05rem;
}

.icon-blue {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.icon-cyan {
  background: #eaf6fc;
  color: #1d7fbf;
}

.icon-violet {
  background: #f1edff;
  color: #6b55b4;
}

.icon-amber {
  background: var(--ca-warning-bg, #fff7e6);
  color: #a96b00;
}

.panel-count,
.trend-legend {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  padding: 0.32rem 0.55rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-bg, #f5f7fb);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.68rem;
  font-weight: 650;
  white-space: nowrap;
}

.trend-legend span {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  background: var(--ca-primary-light, #2850ad);
}

.report-panel-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  padding: 1rem;
}

.report-table {
  display: block;
  min-width: 0;
  overflow-x: auto;
}

.report-panel-body ::ng-deep app-report-table table {
  min-width: 100%;
  margin-bottom: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.report-panel-body ::ng-deep app-report-table thead th {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: #f4f6fa;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.7rem;
  font-weight: 750;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  white-space: nowrap;
}

.report-panel-body ::ng-deep app-report-table tbody td {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: middle;
}

.report-panel-body ::ng-deep app-report-table tbody tr:hover td {
  background: #f7f9fd;
}

.panel-loading {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 220px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.empty-report-state {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  padding: 1.5rem 1rem;
  text-align: center;
}
.empty-report-state h3 {
  margin: 0.65rem 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  font-weight: 700;
}
.empty-report-state p {
  max-width: 300px;
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
  line-height: 1.5;
}

.empty-report-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.15rem;
}

.error-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.compact-empty {
  min-height: 300px;
}

.chart-canvas-wrap {
  position: relative;
  width: 100%;
  height: 300px;
  min-height: 260px;
}

.chart-canvas-wrap canvas {
  display: block;
  max-width: 100%;
}

@media (max-width: 1100px) {
  .report-toolbar-card {
    flex-wrap: wrap;
  }
  .report-action-copy {
    flex: 1 1 12rem;
  }
  .report-actions {
    margin-left: auto;
  }
}
@media (max-width: 850px) {
  .reports-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .report-panel {
    min-height: 300px;
  }
  .report-toolbar-divider {
    display: none;
  }
  .report-action-copy {
    flex-basis: 100%;
  }
  .report-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }
}
@media (max-width: 575.98px) {
  .reports-page {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .reports-header {
    align-items: flex-start;
    gap: 0.7rem;
  }
  .reports-header-mark {
    width: 2.8rem;
    height: 2.8rem;
    flex-basis: 2.8rem;
    font-size: 1.15rem;
  }
  .report-toolbar-card {
    align-items: stretch;
    padding: 0.9rem;
  }
  .filter-block {
    width: 100%;
    min-width: 0;
  }
  .report-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-action-btn {
    padding: 0.6rem 0.5rem;
    font-size: 0.75rem;
  }
  .report-panel-header {
    align-items: flex-start;
    padding: 0.9rem;
  }
  .panel-heading-copy {
    align-items: flex-start;
    gap: 0.55rem;
  }
  .panel-icon {
    width: 2.2rem;
    height: 2.2rem;
    flex-basis: 2.2rem;
    font-size: 0.95rem;
  }
  .panel-count,
  .trend-legend {
    font-size: 0.63rem;
  }
  .report-panel-body {
    padding: 0.7rem;
  }
  .pdf-preview-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-viewer {
    min-height: 360px;
    height: 65vh;
  }
}
@media (prefers-reduced-motion: reduce) {
  .report-panel,
  .report-action-btn {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/reports/reports.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iDAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,YAAA;AAHF;AAKE;EACE,SAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAHJ;AAME;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,wCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,YAAA;EACA,cAAA;AALF;AAOE;EACE,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AALJ;;AASA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,kBAAA;AANF;AAQE;EACE,4CAAA;EACA,gDAAA;AANJ;AASE;EACE,iDAAA;EACA,YAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,UAAA;EACA,2CAAA;AARF;;AAWA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AARF;;AAWA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,kBAAA;EACA,oCAAA;EACA,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uFAAA;AARF;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,mBAAA;EACA,aAAA;AATJ;;AAaA;EACE,wCAAA;EACA,sCAAA;EACA,WAAA;AAVF;AAYE;EACE,6CAAA;EACA,2CAAA;AAVJ;AAaE;EACE,+CAAA;AAXJ;;AAeA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AAZF;AAcE;EACE,8CAAA;EACA,6CAAA;EACA,sCAAA;AAZJ;;AAgBA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;AAbF;;AAgBA;;EAEE,iCAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,wCAAA;EACA,cAAA;AAbF;AAeE;EACE,iBAAA;AAbJ;;AAiBA;EACE,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,iEAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAdF;AAgBE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,0BAAA;AAfJ;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,wCAAA;EACA,gCAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,gDAAA;EACA,oBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;EACA,wDAAA;AAhBF;AAkBE;EACE,uCAAA;EACA,iEAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,wDAAA;EACA,0DAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAjBF;AAmBE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAlBJ;;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,6CAAA;EACA,iCAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,yCAAA;EACA,cAAA;AAnBF;;AAsBA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,iDAAA;EACA,oBAAA;EACA,iCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4CAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,kDAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,wDAAA;EACA,wCAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,yBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AApBJ;;AAwBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,oCAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,wCAAA;EACA,gCAAA;AArBF;;AAwBA;EACE,iBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,eAAA;AArBF;;AAwBA;EACE;IACE,eAAA;EArBF;EAwBA;IACE,eAAA;EAtBF;EAyBA;IACE,iBAAA;EAvBF;AACF;AA0BA;EACE;IACE,qCAAA;EAxBF;EA2BA;IACE,iBAAA;EAzBF;EA4BA;IACE,aAAA;EA1BF;EA6BA;IACE,gBAAA;EA3BF;EA8BA;IACE,WAAA;IACA,cAAA;IACA,2BAAA;EA5BF;AACF;AA+BA;EACE;IACE,sBAAA;IACA,qBAAA;EA7BF;EAgCA;IACE,uBAAA;IACA,WAAA;EA9BF;EAiCA;IACE,aAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;EA/BF;EAkCA;IACE,oBAAA;IACA,eAAA;EAhCF;EAmCA;IACE,WAAA;IACA,YAAA;EAjCF;EAoCA;IACE,aAAA;IACA,gDAAA;EAlCF;EAqCA;IACE,sBAAA;IACA,kBAAA;EAnCF;EAsCA;IACE,uBAAA;IACA,eAAA;EApCF;EAuCA;IACE,uBAAA;IACA,YAAA;EArCF;EAwCA;IACE,aAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;EAtCF;EAyCA;;IAEE,kBAAA;EAvCF;EA0CA;IACE,eAAA;EAxCF;EA2CA;IACE,uBAAA;IACA,sBAAA;EAzCF;EA4CA;IACE,iBAAA;IACA,YAAA;EA1CF;AACF;AA6CA;EACE;;IAEE,gBAAA;EA3CF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.reports-page {\n  width: 100%;\n  min-width: 0;\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n\n.reports-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin: 0 0 1.35rem;\n}\n\n.reports-heading-copy {\n  min-width: 0;\n\n  h1 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: clamp(1.55rem, 2.3vw, 1.95rem);\n    font-weight: 750;\n    letter-spacing: -0.035em;\n    line-height: 1.25;\n  }\n\n  > p:last-child {\n    max-width: 740px;\n    margin: 0.5rem 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.9rem;\n    line-height: 1.6;\n  }\n}\n\n.reports-eyebrow {\n  display: flex;\n  align-items: center;\n  margin: 0 0 0.45rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.69rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.reports-header-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.5rem;\n  height: 3.5rem;\n  flex: 0 0 3.5rem;\n  border: 1px solid rgba(40, 80, 173, 0.15);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.45rem;\n}\n\n.report-toolbar-card {\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n  min-width: 0;\n  margin-bottom: 1.25rem;\n  padding: 1rem 1.15rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.filter-block {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  min-width: 15rem;\n}\n\n.toolbar-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.7rem;\n  height: 2.7rem;\n  flex: 0 0 2.7rem;\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.05rem;\n}\n\n.filter-copy {\n  min-width: 0;\n  flex: 1 1 auto;\n\n  .form-label {\n    display: block;\n    margin: 0 0 0.25rem;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.74rem;\n    font-weight: 650;\n  }\n}\n\n.report-filter {\n  width: 100%;\n  min-width: 10.5rem;\n  min-height: 2.5rem;\n  border-color: var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.85rem;\n\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n  }\n\n  &:disabled {\n    background-color: var(--ca-bg-secondary, #eef2f8);\n    cursor: wait;\n  }\n}\n\n.report-toolbar-divider {\n  align-self: stretch;\n  width: 1px;\n  background: var(--ca-border-light, #e9edf3);\n}\n\n.report-action-copy {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 10rem;\n}\n\n.toolbar-label {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.toolbar-hint {\n  margin-top: 0.2rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.75rem;\n}\n\n.report-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n}\n\n.report-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.5rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.82rem;\n  font-weight: 650;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n\n  i {\n    font-size: 0.95rem;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n  }\n}\n\n.reports-page .btn-primary {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.2);\n  }\n}\n\n.reports-page .btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary-light, #2850ad);\n    background: var(--ca-surface-active, #eef3ff);\n    color: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n.reports-loading-banner,\n.reports-alert {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin: 0 0 1rem;\n  padding: 0.8rem 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.reports-loading-banner .spinner-border,\n.panel-loading .spinner-border {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.reports-alert-error {\n  border-color: #f3b9c0;\n  background: var(--ca-danger-bg, #fdecef);\n  color: #842029;\n\n  .btn {\n    margin-left: auto;\n  }\n}\n\n.pdf-preview-panel {\n  overflow: hidden;\n  margin: 0 0 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n}\n\n.pdf-preview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.2rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fbfcff;\n}\n\n.pdf-preview-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.95rem;\n    font-weight: 750;\n  }\n\n  p {\n    margin: 0.2rem 0 0;\n    color: var(--ca-text-tertiary, #6f7b91);\n    font-size: 0.75rem;\n    text-transform: capitalize;\n  }\n}\n\n.pdf-preview-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  flex: 0 0 2.5rem;\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n  font-size: 1.1rem;\n}\n\n.close-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex: 0 0 auto;\n  font-size: 0.8rem;\n}\n\n.pdf-viewer {\n  display: block;\n  width: 100%;\n  height: min(78vh, 900px);\n  min-height: 440px;\n  border: 0;\n  background: #eef2f8;\n}\n\n.reports-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 1.15rem;\n}\n\n.report-panel {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 350px;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    border-color: var(--ca-border, #dfe4ec);\n    box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n  }\n}\n\n.report-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  min-height: 5.35rem;\n  padding: 1rem 1.1rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);\n}\n\n.panel-heading-copy {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.96rem;\n    font-weight: 750;\n    line-height: 1.35;\n  }\n\n  p {\n    margin: 0.25rem 0 0;\n    color: var(--ca-text-tertiary, #6f7b91);\n    font-size: 0.75rem;\n    line-height: 1.45;\n  }\n}\n\n.panel-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.55rem;\n  height: 2.55rem;\n  flex: 0 0 2.55rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 1.05rem;\n}\n\n.icon-blue {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.icon-cyan {\n  background: #eaf6fc;\n  color: #1d7fbf;\n}\n\n.icon-violet {\n  background: #f1edff;\n  color: #6b55b4;\n}\n\n.icon-amber {\n  background: var(--ca-warning-bg, #fff7e6);\n  color: #a96b00;\n}\n\n.panel-count,\n.trend-legend {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n  padding: 0.32rem 0.55rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: var(--ca-bg, #f5f7fb);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.68rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.trend-legend span {\n  width: 0.42rem;\n  height: 0.42rem;\n  border-radius: 50%;\n  background: var(--ca-primary-light, #2850ad);\n}\n\n.report-panel-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  padding: 1rem;\n}\n\n.report-table {\n  display: block;\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.report-panel-body ::ng-deep app-report-table table {\n  min-width: 100%;\n  margin-bottom: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n}\n\n.report-panel-body ::ng-deep app-report-table thead th {\n  padding: 0.75rem 0.8rem;\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\n  background: #f4f6fa;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.7rem;\n  font-weight: 750;\n  letter-spacing: 0.025em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.report-panel-body ::ng-deep app-report-table tbody td {\n  padding: 0.75rem 0.8rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  color: var(--ca-text-secondary, #4b5870);\n  vertical-align: middle;\n}\n\n.report-panel-body ::ng-deep app-report-table tbody tr:hover td {\n  background: #f7f9fd;\n}\n\n.panel-loading {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  min-height: 220px;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.empty-report-state {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n  padding: 1.5rem 1rem;\n  text-align: center;\n\n  h3 {\n    margin: 0.65rem 0 0.25rem;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.9rem;\n    font-weight: 700;\n  }\n\n  p {\n    max-width: 300px;\n    margin: 0;\n    color: var(--ca-text-tertiary, #6f7b91);\n    font-size: 0.78rem;\n    line-height: 1.5;\n  }\n}\n\n.empty-report-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.7rem;\n  height: 2.7rem;\n  border-radius: 50%;\n  background: var(--ca-bg-secondary, #eef2f8);\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 1.15rem;\n}\n\n.error-icon {\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n}\n\n.compact-empty {\n  min-height: 300px;\n}\n\n.chart-canvas-wrap {\n  position: relative;\n  width: 100%;\n  height: 300px;\n  min-height: 260px;\n}\n\n.chart-canvas-wrap canvas {\n  display: block;\n  max-width: 100%;\n}\n\n@media (max-width: 1100px) {\n  .report-toolbar-card {\n    flex-wrap: wrap;\n  }\n\n  .report-action-copy {\n    flex: 1 1 12rem;\n  }\n\n  .report-actions {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 850px) {\n  .reports-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .report-panel {\n    min-height: 300px;\n  }\n\n  .report-toolbar-divider {\n    display: none;\n  }\n\n  .report-action-copy {\n    flex-basis: 100%;\n  }\n\n  .report-actions {\n    width: 100%;\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .reports-page {\n    padding-right: 0.25rem;\n    padding-left: 0.25rem;\n  }\n\n  .reports-header {\n    align-items: flex-start;\n    gap: 0.7rem;\n  }\n\n  .reports-header-mark {\n    width: 2.8rem;\n    height: 2.8rem;\n    flex-basis: 2.8rem;\n    font-size: 1.15rem;\n  }\n\n  .report-toolbar-card {\n    align-items: stretch;\n    padding: 0.9rem;\n  }\n\n  .filter-block {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .report-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .report-action-btn {\n    padding: 0.6rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .report-panel-header {\n    align-items: flex-start;\n    padding: 0.9rem;\n  }\n\n  .panel-heading-copy {\n    align-items: flex-start;\n    gap: 0.55rem;\n  }\n\n  .panel-icon {\n    width: 2.2rem;\n    height: 2.2rem;\n    flex-basis: 2.2rem;\n    font-size: 0.95rem;\n  }\n\n  .panel-count,\n  .trend-legend {\n    font-size: 0.63rem;\n  }\n\n  .report-panel-body {\n    padding: 0.7rem;\n  }\n\n  .pdf-preview-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pdf-viewer {\n    min-height: 360px;\n    height: 65vh;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .report-panel,\n  .report-action-btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
